import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {openInBrowser} from '../../../../srcCommon/browser/openInBrowser';

/*
 * Style.
 */

const StyledButtonContent = styled.div`
  display: flex;
  align-items: center;
`;

const StyledIcon = styled(Icon)`
  margin-left: 4px;
  margin-top: 1px;
`;

/*
 * Props.
 */

export interface LearnMoreButtonProps {
  helpPageUrl: string;
  size?: VisualSizesEnum;
  variant?: ButtonVariantsEnum;
  className?: string;

  /**
   * Called along with openInBrowser when the button is clicked.
   * Specify this prop to add tracking to the button click.
   */
  onClick?: Handler;
}

/*
 * Component.
 */

export const LearnMoreButton: FC<LearnMoreButtonProps> = ({
  helpPageUrl,
  size = VisualSizesEnum.MEDIUM,
  variant = ButtonVariantsEnum.SECONDARY,
  className,
  onClick,
}) => (
  <Button
    size={size}
    variant={variant}
    onClick={() => {
      onClick?.();
      openInBrowser(helpPageUrl);
    }}
    className={className}
  >
    <StyledButtonContent>
      <Trans id="upsell-button-learn-more">Learn more</Trans>
      <StyledIcon name="externalLinkSmall" />
    </StyledButtonContent>
  </Button>
);
